import React from 'react';
import cx from 'classnames';

import { HeaderBanner } from '@husslehq/api-client-ts';

import { User } from '../../types/authentication';

import { useMediaQuery } from '../../hooks';

import { track } from '../../services/analytics';

import { Header } from '../../components/Header/Header';

import { AppDownload, Footer } from '@husslehq/ui-library';

import styles from '../../components/Layout/Layout.module.scss';

export type LayoutProps = {
  backgroundColor?: 'white' | 'light-grey';
  showAppDownload?: boolean;
  className?: string;
  basketAmount?: string;
  user?: User;
  headerBanner?: HeaderBanner;
};

export const Layout: React.FC<LayoutProps> = ({
  backgroundColor = 'white',
  showAppDownload,
  className = '',
  basketAmount,
  user,
  children,
  headerBanner,
}) => {
  const isMobile = useMediaQuery(767);
  const walletAmount = 0;
  const hasGift = false;
  const basketCount = 1;
  const isLoggedIn = !!user;
  const feedbackRequired = 0;

  const trackAppDownload = (label: string) => {
    track({
      event: 'gym_spa',
      category: 'OnClick',
      action: 'Search Page',
      label: label,
    });
  };

  const trackLinks = (label: string) => {
    track({
      event: 'gym_spa',
      category: 'OnClick',
      action: 'Footer',
      label: label,
    });
  };

  return (
    <div className={cx(styles.layout, { [styles['layout--' + backgroundColor]]: backgroundColor }, className)}>
      <Header
        isLoggedIn={isLoggedIn}
        isMobile={isMobile}
        basketCount={basketCount}
        basketAmount={basketAmount}
        walletAmount={walletAmount}
        hasGift={hasGift}
        feedback={feedbackRequired}
        headerBanner={headerBanner}
      />
      {children}
      {showAppDownload && (
        <AppDownload
          onAppStoreClick={() => trackAppDownload('Itunes Button')}
          onPlayStoreClick={() => trackAppDownload('Google Play Button')}
        />
      )}
      <Footer isMobile={isMobile} onLinkClick={trackLinks} />
    </div>
  );
};
